import { AUTHPATHS, PRIVATEPATHS } from '@core/enums/paths.enum';
import Pages404 from 'pages/AuthenticationInner/Pages404';
import Alert from 'Views/Alert/Alert';
import Audit from 'Views/Audit/Audit';
import Batch from 'Views/Batch/Batch';
import BatchDetail from 'Views/Batch/BatchDetail';
import Bullk from 'Views/Bullk/Bullk';
import Comments from 'Views/Comments/Comments';
import Dashboard from 'Views/Dashboard/Dashboard';
import Dosage from 'Views/Dosage/Dosage';
import Epcis from 'Views/Epcis/Epcis';
import SftpIntegrations from 'Views/SftpIntegration/SftpIntegrations';
import SftpPartners from 'Views/SftpIntegration/SftpPartners';
import SftpTransferDetail from 'Views/SftpIntegration/SftpTransferDetail';
import As2Messages from 'Views/As2Integration/As2Messages';
import As2Partners from 'Views/As2Integration/As2Partners';
import As2MessageDetail from 'Views/As2Integration/As2MessageDetail';
import IntegrationsHub from 'Views/Integrations/IntegrationsHub';
import InventoryManagement from 'Views/InventoryManagement/InventoryManagement';
import Login from 'Views/Login/Login';
import Manufacturer from 'Views/Manufacturer/Manufacturer';
import CustomersMap from 'Views/Map/CustomersMap';
import Offers from 'Views/Offers/Offers';
import Orders from 'Views/Orders/Orders';
import Backorders from 'Views/Backorders/Backorders';
import ProductCategory from 'Views/ProductCategory/ProductCategory';
import ProductLifeCycle from 'Views/ProductLifeCycle/ProductLifeCycle';
import Products from 'Views/Products/Products';
import ProductSubCategory from 'Views/ProductSubCategory/ProductSubCategory';
import Returns from 'Views/Returns/Returns';
import Shipments from 'Views/Shipments/Shipments';
import ContactSubmissions from 'Views/ContactSubmissions/ContactSubmissions';
import PosSettings from 'Views/PosSettings/PosSettings';
import Supplier from 'Views/Supplier/Supplier';
import Tier from 'Views/Tier/Tier';
import Traceability from 'Views/Traceability/Traceability';
import TransactionStatements from 'Views/TransactionStatements/TransactionStatements';
import Users from 'Views/Users/Users';
import WareHouse from 'Views/WareHouse/WareHouse';

interface RouteObject {
    path: PRIVATEPATHS | `${PRIVATEPATHS}/:${string}` | `/`;
    component: React.ComponentType<any>;
    exact?: boolean;
}

const privateRoutes: RouteObject[] = [
    // -------------------------------------------------------
    { path: `/`, component: Dashboard },
    { path: PRIVATEPATHS.Dashboard, component: Dashboard },
    { path: PRIVATEPATHS.UserListing, component: Users },
    { path: PRIVATEPATHS.Offers, component: Offers },
    { path: PRIVATEPATHS.Products, component: Products },
    { path: PRIVATEPATHS.Dosage, component: Dosage },
    { path: PRIVATEPATHS.Tier, component: Tier },
    { path: PRIVATEPATHS.Warehouse, component: WareHouse },
    { path: PRIVATEPATHS.Manufacturer, component: Manufacturer },
    { path: PRIVATEPATHS.Supplier, component: Supplier },
    { path: PRIVATEPATHS.ProductCategory, component: ProductCategory },
    { path: PRIVATEPATHS.ProductSubCategory, component: ProductSubCategory },
    { path: PRIVATEPATHS.Batch, component: Batch },
    { path: `${PRIVATEPATHS.Batch}/:id`, component: BatchDetail },
    { path: PRIVATEPATHS.InventoryManagement, component: InventoryManagement },
    { path: PRIVATEPATHS.ProductLifeCycle, component: ProductLifeCycle },
    { path: PRIVATEPATHS.Traceability, component: Traceability },
    { path: PRIVATEPATHS.TransactionStatements, component: TransactionStatements },
    { path: PRIVATEPATHS.Audit, component: Audit },
    { path: PRIVATEPATHS.Epcis, component: Epcis },
    { path: PRIVATEPATHS.SftpIntegrations, component: SftpIntegrations },
    { path: PRIVATEPATHS.SftpPartners, component: SftpPartners },
    { path: `${PRIVATEPATHS.SftpIntegrations}/:id`, component: SftpTransferDetail },
    { path: PRIVATEPATHS.Integrations, component: IntegrationsHub },
    { path: PRIVATEPATHS.As2Messages, component: As2Messages },
    { path: PRIVATEPATHS.As2Partners, component: As2Partners },
    { path: `${PRIVATEPATHS.As2Messages}/:id`, component: As2MessageDetail },
    { path: PRIVATEPATHS.Bullk, component: Bullk },
    { path: PRIVATEPATHS.Orders, component: Orders },
    { path: PRIVATEPATHS.Backorders, component: Backorders },
    { path: PRIVATEPATHS.Comments, component: Comments },
    { path: PRIVATEPATHS.Alert, component: Alert },
    { path: PRIVATEPATHS.Map, component: CustomersMap },
    { path: PRIVATEPATHS.Returns, component: Returns },
    { path: PRIVATEPATHS.Shipments, component: Shipments },
    { path: PRIVATEPATHS.ContactSubmissions, component: ContactSubmissions },
    { path: PRIVATEPATHS.PosSettings, component: PosSettings },
    // -------------------------------------------------------
];

const authRoutes = [
    // { path: AUTHPATHS.ResetPassword, component: ResetPassword },
    { path: `*`, component: Pages404 },
    { path: AUTHPATHS.Login, component: Login },
];

export { privateRoutes, authRoutes };
